<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg5 class="head_contain">
          <p class="table_card__head--title">
            Características de usuario
          </p>
        </v-flex>
        <v-flex xs12 lg7 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'new_segments_data'})"
            >
              Importar datos
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="findSegments()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <section class="classes__container">
        <section
          class="data_card"
          v-for="segment in segments" style="cursor:pointer;"
          :key="segment.id" v-if="segment.attributes.name!='default'" @click="$router.push({name: 'segments_value', params: {id: segment.id, name: segment.attributes.name.toLowerCase() }});">
          <!-- <div
            class="data_card__image"
            :style="{backgroundImage: 'url('+ getImageServer() + segment.images[0].attributes.image.url +')'}"></div> -->
          <div class="data_card__buttons">
            <div class="data_card__buttons--container">
              <div
                class="data_card__buttons--edit"
                style="top: 20px;position: absolute;right: 5px;"
                @click="$router.push({name: 'segments_value', params: {id: segment.id, name: segment.attributes.name.toLowerCase() }});">
                <v-icon>search</v-icon>
              </div>
            </div>
          </div>
          <div class="data_card__info">
            <p class="data_card__info--title">
              {{segment.attributes.name.charAt(0).toUpperCase()+ segment.attributes.name.slice(1)}}
            </p>
          </div>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      segments:[],
      images: [],
      charged: false,

    }
  },
  methods:{
    findSegments(){
      try {
        const data = {company: {id: this.getCompany().id}}
        this.$http.post('segments/company',
        {data:this.encrypt(data).toString()},
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          this.segments = response.body.data
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      }
      catch (e) {
        alert(e.message)
      }
    }
  },
  mounted(){
    this.findSegments();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/segments/Index.vue